import { Modal } from 'antd';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { Waypoint } from 'react-waypoint';

import styles from '../style/GetStartedModal.module.scss';

type PrivateProps = {
  visible: boolean;
  onHandleGetStartedModalCancel: () => void;
  handleCloseAllModals: () => void;
};

export default function GetStartedModal({
  visible,
  onHandleGetStartedModalCancel,
  handleCloseAllModals,
}: PrivateProps) {
  const [activeLink, setActiveLink] = useState('download');

  return (
    <Modal
      className={`getStartedModal ${styles.getStartedModal}`}
      title={[
        <div
          className={styles.titleContainer}
          key={'getStartedModal-title-container'}
        >
          <h1>Get Started</h1>
          <div></div>
        </div>,
      ]}
      visible={visible}
      onCancel={onHandleGetStartedModalCancel}
      // width={'65vw'}
      footer={[
        <div key="getStartedModal-footerText"></div>,
        //  <Button key="back" onClick={handleAnalyticsCancel}>Close</Button>
      ]}
    >
      <div className={styles.getStartedModalContent}>
        <div className={styles.listNavigation}>
          <a
            className={`${activeLink === 'download' ? styles.active : ''}`}
            href="#download"
          >
            Download
          </a>
          <a
            className={`${activeLink === 'validate' ? styles.active : ''}`}
            href="#validate"
          >
            Validate
          </a>
          <a
            className={`${
              activeLink === 'mood-webinar-2022' ? styles.active : ''
            }`}
            href="#mood-webinar-2022"
          >
            MOOD Webinar 2022
          </a>
        </div>
        <div className={styles.content}>
          <section id="download">
            <div className={styles.sectionContainer}>
              <Waypoint onPositionChange={() => setActiveLink('download')}>
                <h2>Download</h2>
              </Waypoint>
              <div className={styles.reactPlayer}>
                <ReactPlayer
                  url="https://www.youtube.com/watch?v=19Ne0Uq0ze0"
                  controls={true}
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </section>
          <section id="validate">
            <div className={styles.sectionContainer}>
              <Waypoint onPositionChange={() => setActiveLink('validate')}>
                <h2>Validate</h2>
              </Waypoint>
              <div className={styles.reactPlayer}>
                <ReactPlayer
                  url="https://www.youtube.com/watch?v=MJj3DcSIaLA"
                  controls={true}
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </section>
          <section id="mood-webinar-2022">
            <div className={styles.sectionContainer}>
              <Waypoint
                onPositionChange={() => setActiveLink('mood-webinar-2022')}
              >
                <h2>MOOD Webinar 2022</h2>
              </Waypoint>
              <div className={styles.reactPlayer}>
                <ReactPlayer
                  url="https://www.youtube.com/watch?v=pduwYau5coM"
                  controls={true}
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </Modal>
  );
}
